import * as React from 'react';
import * as classnames from 'classnames/bind';
import {MouseEventHandler, Ref} from 'react';

const styles = require('./Row.less');
const cx = classnames.bind(styles);

export interface RowProps
{
    aRef?:React.Ref<any>;
    className?:string;
    onClick?:MouseEventHandler<any>;
    onDoubleClick?:MouseEventHandler<any>;
    onMouseOver?:MouseEventHandler<any>;
    dangerouslySetInnerHTML?:any;
}

export class Row extends React.Component<RowProps, any>
{
    constructor(props:any)
    {
        super(props);
    }

    render()
    {
        const {className, onClick, onDoubleClick, onMouseOver, aRef, dangerouslySetInnerHTML} = this.props;

        return <div className={cx('row', className)}
                    onClick={onClick}
                    onDoubleClick={onDoubleClick}
                    onMouseOver={onMouseOver}
                    ref={aRef}
                    dangerouslySetInnerHTML={dangerouslySetInnerHTML}>
                    { this.props.children }
               </div>;
    }
}